import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { Footer } from "../../components/Shared/Footer/Footer";
import UserRegistrationInputFirst from "./components/UserRegistrationInputsFirst";
import UserRegistrationInputSecond from "./components/UserregistrationInputSecond";
import {
  UserRegistrationInitialGetInterface,
  UserRegistrationInputFirstInputs,
  UserRegistrationInputSecondInputs,
  userDetails,
  contactDetails,
  contactData,
  UserRegistrationInitialPostResponse,
  userDetailsValidationStatus,
  UsernameCheckPostInterface,
} from "./UserRegistration.models";
import { UserRegistrationService } from "./UserRegistration.service";
import { UserRegistrationInitialGetModel } from "../../models";
import "./UserRegistration.scss";
import ProfilePictureCompo from "./components/ProfilePic/ProfilePic";
import { AuthService } from "../../services/authService";
import _ from "lodash";

const UserRegistration: React.FC = () => {
  const [profilePicture, setProfilePicture] = useState<{ profilePic: string }>({
    profilePic: "",
  });

  const [initialGetData, setInitialGetData] =
    useState<UserRegistrationInitialGetModel>();

  const [postResult, setPostResult] =
    useState<UserRegistrationInitialPostResponse>();

  const validationKeeper = {
    firstName: {
      req: false,
      isInputed: false,
    },
    lastName: {
      req: false,
      isInputed: false,
    },
    userName: {
      req: false,
      exist: false,
      minLength: false,
      isInputed: false,
    },
    password: {
      req: false,
      notStrong: false,
      isInputed: false,
    },
    confirmPassword: {
      req: false,
      notMacth: false,
      isInputed: false,
    },
    network: {
      req: false,
      isInputed: false,
    },
  };
  const [validation, setValidation] =
    useState<userDetailsValidationStatus>(validationKeeper);

  const [typeValidation, setTypeValidation] = useState<{
    primaryType: boolean;
    secondaryType: boolean;
  }>({ primaryType: false, secondaryType: false });

  useIonViewWillEnter(() => {
    AuthService.clearStorage();
  });

  const onPassword = () => {
    const value: any = userDetailsInput.password.current!.value;
    const hasLetter = /[a-zA-Z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);

    const isOk = hasSpecialChar && hasNumber && hasLetter && value.length >= 8;
    if (!isOk) {
      setValidation({
        ...validation,
        password: { ...validation.password, notStrong: false, isInputed: true },
      });
    } else {
      setValidation({
        ...validation,
        password: { ...validation.password, notStrong: true, isInputed: true },
      });
      if (
        userDetailsInput.password.current!.value ===
        userDetailsInput.confrimPassword.current!.value
      ) {
        setValidation({
          ...validation,
          password: {
            ...validation.password,
            notStrong: true,
            isInputed: true,
          },
          confirmPassword: { ...validation.confirmPassword, notMacth: true },
        });
      } else {
        setValidation({
          ...validation,
          password: {
            ...validation.password,
            notStrong: true,
            isInputed: true,
          },
          confirmPassword: { ...validation.confirmPassword, notMacth: false },
        });
      }
    }
  };

  const onConfirmPassword = () => {
    if (
      userDetailsInput.password.current!.value ===
      userDetailsInput.confrimPassword.current!.value
    ) {
      setValidation({
        ...validation,
        confirmPassword: {
          ...validation.confirmPassword,
          notMacth: true,
          isInputed: true,
        },
      });
    } else {
      setValidation({
        ...validation,
        confirmPassword: {
          ...validation.confirmPassword,
          notMacth: false,
          isInputed: true,
        },
      });
    }
  };

  const fetchUsername = async () => {
    const respResult: UsernameCheckPostInterface =
      await UserRegistrationService.userNameGet(paramsUsername());
    if (respResult.isSuccess) {
      setValidation({
        ...validation,
        userName: {
          ...validation.userName,
          exist: respResult.usernameExist!,
          minLength: true,
          isInputed: true,
        },
      });
    } else {
      UserRegistrationService.handleErrorResponse();
    }
  };

  const onUsername = () => {
    if (
      userDetailsInput.userName.current!.value &&
      userDetailsInput.userName.current!.value.toString().length >= 6
    ) {
      setValidation({
        ...validation,
        userName: { ...validation.userName, minLength: true, isInputed: true },
      });
    } else {
      setValidation({
        ...validation,
        userName: { ...validation.userName, minLength: false, isInputed: true },
      });
    }
    if (
      userDetailsInput.userName.current!.value &&
      userDetailsInput.userName.current!.value.toString().length >= 6 &&
      !(userDetailsInput.userName.current!.value === initialGetData?.userName)
    ) {
      fetchUsername();
    }
  };

  const onFirstName = () => {
    const value: any = userDetailsInput?.firstName?.current?.value;
    const alphabeticValue: any = value.replace(/[^a-zA-Z]/g, "");
    userDetailsInput.firstName.current!.value=alphabeticValue
    if (!_.isEmpty(userDetailsInput.firstName.current!.value)) {
      setValidation({
        ...validation,
        firstName: { ...validation.firstName, req: true, isInputed: true },
      });
    } else {
      setValidation({
        ...validation,
        firstName: { ...validation.firstName, req: false, isInputed: true },
      });
    }
  };
  const onLastName = () => {
    const value: any = userDetailsInput?.lastName?.current?.value;
    const alphabeticValue: any = value.replace(/[^a-zA-Z]/g, "");
    userDetailsInput.lastName.current!.value=alphabeticValue
    if (!_.isEmpty(userDetailsInput.lastName.current!.value)) {
      setValidation({
        ...validation,
        lastName: { ...validation.lastName, req: true, isInputed: true },
      });
    } else {
      setValidation({
        ...validation,
        lastName: { ...validation.lastName, req: false, isInputed: true },
      });
    }
  };

  const onNetwork = () => {
    validationKeeper.network.isInputed = true;
    if (!_.isEmpty(userDetailsInput.network.current!.value)) {
      validationKeeper.network.req = true;
      // setValidation(validationKeeper);
    } else {
      validationKeeper.network.req = false;
      // setValidation(validationKeeper);
    }
  };

  const [contact, setContact] = useState<boolean>(false);

  const firstNameInputRef = useRef<HTMLIonInputElement>(null);
  const lastNameInputRef = useRef<HTMLIonInputElement>(null);
  const displayNameInputRef = useRef<HTMLIonInputElement>(null);
  const userNameInputRef = useRef<HTMLIonInputElement>(null);
  const passwordInputRef = useRef<HTMLIonInputElement>(null);
  const confirmPasswordInputRef = useRef<HTMLIonInputElement>(null);
  const networkInputRef = useRef<HTMLIonInputElement>(null);
  const emilInputRef = useRef<HTMLIonInputElement>(null);
  const pagerInputRef = useRef<HTMLIonInputElement>(null);
  const primaryPhoneInputRef = useRef<HTMLIonInputElement>(null);
  const secondaryPhoneInputRef = useRef<HTMLIonInputElement>(null);
  const perimaryPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const secondaryPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const emailPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const pagerPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const perimaryTypeRef = useRef<HTMLIonSelectElement>(null);
  const secondaryTypeRef = useRef<HTMLIonSelectElement>(null);
  const iAgreeTermsCheckBoxRef = useRef<HTMLInputElement>(null);
  const iAgreePrivacyCheckBoxRef = useRef<HTMLInputElement>(null);

  const paramsIntialGet = () => {
    const url = document.URL.split("/");
    return {
      reg_code: url[url.length - 1],
      guid: url[url.length - 2],
    };
  };

  const paramsUsername = () => {
    const url = document.URL.split("/");
    return {
      reg_code: url[url.length - 1],
      guid: url[url.length - 2],
      username: "" + userDetailsInput.userName.current!.value,
    };
  };

  const inputData = {
    guid: paramsIntialGet().guid,
    firstName: initialGetData ? initialGetData!.firstName : "",
    lastName: initialGetData ? initialGetData!.lastName : "",
    displayName: "",
    userName: initialGetData ? initialGetData!.userName : "",
    password: "",
    confrimPassword: "",
    network: paramsIntialGet().reg_code,
    email: initialGetData ? initialGetData!.email : "",
    pager: initialGetData ? initialGetData?.pager : "",
    primaryPhone: "",
    primaryType: 0,
    secondPhone: "",
    secondType: 3,
    profile_pic: initialGetData ? initialGetData!.profile_pic : "",
    contactDetails: initialGetData ? initialGetData!.contactDetails : [],
    contact_preference: initialGetData
      ? initialGetData.contact_preference
      : { email: 0, pager: 0, alternate_number: 0, mobile_number: 0 },
  };

  const [inputUserDetails, setInputUserDetails] =
    useState<userDetails>(inputData);

  const [inputContactDetailsInit, setInputContactDetailsInit] = useState<
    contactDetails[]
  >(inputData.contactDetails);

  const [inputContactDetailsData, setInputContactDetailsData] =
    useState<contactData>(inputData);

  const userDetailsSubmit = () => {
    inputData.firstName = "" + userDetailsInput.firstName.current!.value;
    inputData.lastName = "" + userDetailsInput.lastName.current!.value;
    inputData.displayName = "" + userDetailsInput.displayName.current!.value;
    inputData.userName = "" + userDetailsInput.userName.current!.value;
    inputData.password = "" + userDetailsInput.password.current!.value;
    inputData.confrimPassword =
      "" + userDetailsInput.confrimPassword.current!.value;
    inputData.network = "" + userDetailsInput.network.current!.value;
    inputData.profile_pic = profilePicture.profilePic;

    setInputUserDetails(inputData);
    setContact(true);
  };

  const contactDetailsBack = () => {
    inputData.email = "" + contactDetailsInput.email.current!.value;
    inputData.pager = "" + contactDetailsInput.pager.current!.value;
    inputData.primaryPhone =
      "" + contactDetailsInput.primaryPhone.current!.value;
    inputData.primaryPhone = inputData.primaryPhone.replace(/[^\d]/g, "");
    inputData.primaryType = +(
      "" + contactDetailsInput.primaryType.current!.value
    );
    inputData.secondPhone =
      "" + contactDetailsInput.secondryPhone.current!.value;
    inputData.secondPhone = inputData.secondPhone.replace(/[^\d]/g, "");
    inputData.secondType = +(
      "" + contactDetailsInput.secondryType.current!.value
    );
    inputData.contact_preference.email = +(
      "" + contactDetailsInput.emailPreferance.current!.value
    );
    inputData.contact_preference.pager = +(
      "" + contactDetailsInput.pagerPreferance.current!.value
    );
    inputData.contact_preference.mobile_number = +(
      "" + contactDetailsInput.primaryPreferance.current!.value
    );
    inputData.contact_preference.alternate_number = +(
      "" + contactDetailsInput.secondryPreferance.current!.value
    );
    setInputContactDetailsData(inputData);
    setContact(false);
  };
  const typeSavePrimary = (valuep: number, values: number) => {
    inputData.primaryType = valuep;
    inputData.secondType = values;
    setInputContactDetailsData(inputData);
  };

  const typeSaveSecondary = (valuep: number, values: number) => {
    inputData.secondType = values;
    inputData.primaryType = valuep;
    setInputContactDetailsData(inputData);
  };

  const getPagerDetails = (pagerValue: any) => {
    if (pagerValue) {
      return pagerValue;
    } else {
      return "";
    }
  };

  const save = () => {
    inputData.email = "" + contactDetailsInput.email.current!.value;
    inputData.pager =
      "" + getPagerDetails(contactDetailsInput.pager.current!.value);
    inputData.primaryPhone =
      "" + contactDetailsInput.primaryPhone.current!.value;
    inputData.primaryPhone = inputData.primaryPhone.replace(/[^\d]/g, "");
    inputData.primaryType = +(
      "" + contactDetailsInput.primaryType.current!.value
    );
    inputData.secondPhone =
      "" + contactDetailsInput.secondryPhone.current!.value;
    inputData.secondPhone = inputData.secondPhone.replace(/[^\d]/g, "");
    inputData.secondType = +(
      "" + contactDetailsInput.secondryType.current!.value
    );
    inputData.contact_preference.email = +(
      "" + contactDetailsInput.emailPreferance.current!.value
    );
    inputData.contact_preference.pager = +(
      "" + contactDetailsInput.pagerPreferance.current!.value
    );
    inputData.contact_preference.mobile_number = +(
      "" + contactDetailsInput.primaryPreferance.current!.value
    );
    inputData.contact_preference.alternate_number = +(
      "" + contactDetailsInput.secondryPreferance.current!.value
    );
    inputData.firstName = inputUserDetails.firstName;
    inputData.lastName = inputUserDetails.lastName;
    inputData.displayName = inputUserDetails.displayName;
    inputData.userName = inputUserDetails.userName;
    inputData.password = inputUserDetails.password;
    inputData.confrimPassword = inputUserDetails.confrimPassword;
    inputData.profile_pic = inputUserDetails.profile_pic;
    updateUserRegistration();
  };

  const userDetailsInput: UserRegistrationInputFirstInputs = {
    firstName: firstNameInputRef,
    lastName: lastNameInputRef,
    displayName: displayNameInputRef,
    userName: userNameInputRef,
    password: passwordInputRef,
    confrimPassword: confirmPasswordInputRef,
    network: networkInputRef,
  };

  const contactDetailsInput: UserRegistrationInputSecondInputs = {
    email: emilInputRef,
    pager: pagerInputRef,
    primaryPhone: primaryPhoneInputRef,
    secondryPhone: secondaryPhoneInputRef,
    primaryPreferance: perimaryPreferanceRef,
    secondryPreferance: secondaryPreferanceRef,
    primaryType: perimaryTypeRef,
    secondryType: secondaryTypeRef,
    iAgreeTerms: iAgreeTermsCheckBoxRef,
    iAgreePrivacy: iAgreePrivacyCheckBoxRef,
    pagerPreferance: pagerPreferanceRef,
    emailPreferance: emailPreferanceRef,
  };

  const loadUserRegistrationIntialGet = () => {
    if (initialGetData?.linkStatus === false) {
      window.location.href = "/login";
    }
    userDetailsInput.firstName.current!.value = initialGetData
      ? initialGetData!.firstName
      : "";
    userDetailsInput.lastName.current!.value = initialGetData
      ? initialGetData!.lastName
      : "";
    userDetailsInput.userName.current!.value = "";
    userDetailsInput.displayName.current!.value = initialGetData
      ? initialGetData!.displayName
      : "";
    setProfilePic(initialGetData ? initialGetData.profile_pic : "");
  };

  const fetchUserRegistrationIntialGet = async () => {
    const respResult: UserRegistrationInitialGetInterface =
      await UserRegistrationService.userRegistrationInitialGet(
        paramsIntialGet()
      );
    respResult.isSuccess
      ? setInitialGetData(respResult.UserRegistrationIntialGet)
      : UserRegistrationService.handleErrorResponse();
  };

  const updateUserRegistration = async () => {
    const respResult: UserRegistrationInitialPostResponse =
      await UserRegistrationService.userRegistrationIntialPost(
        inputData,
        paramsIntialGet().reg_code
      );
    respResult.isSuccess
      ? setPostResult(respResult)
      : UserRegistrationService.handleErrorResponse();
  };

  useEffect(() => {
    fetchUserRegistrationIntialGet();
  }, []);

  useEffect(() => {
    document.body.className = "dark-theme";
  }, []);

  useEffect(() => {
    if (postResult?.isSuccess === true) {
      window.location.href = "login";
    }
  }, [postResult]);

  useEffect(() => {
    loadUserRegistrationIntialGet();
    setInputUserDetails(inputData);
    setInputContactDetailsInit(inputData.contactDetails);
    setInputContactDetailsData(inputData);
  }, [initialGetData]);

  const setProfilePic = (bPic: string) => {
    setProfilePicture({ profilePic: bPic });
  };

  return (
    <IonPage>
      <IonContent className="ion-padding" color="dark">
        <div className="reg-container">
          <div className="reg-input-container">
            <div className="callcentral-logo-container">
              <div className="logo-wrapper">
                <img
                  className="callcentral-logo"
                  src="assets/icon/logoIcon.svg"
                  alt="Nserix"
                />
                
              </div>
            </div>

            <div className="profilepic-input-header-container">
              {!contact && (
                <ProfilePictureCompo
                  key={profilePicture.profilePic}
                  setProfilePic={setProfilePic}
                  initValue={profilePicture.profilePic}
                ></ProfilePictureCompo>
              )}

              <div className="login-input-header">
                <div className="welcome-wrapper">
                  <span className="welcome">Sign Up</span>
                </div>
                <div id="header-title-div">
                  <span className="header-title">
                    Let's create your account
                  </span>
                </div>
              </div>
            </div>
            <div className="login-input-wrapper">
              {contact ? (
                <UserRegistrationInputSecond
                  isTermsPrivacyActive={true}
                  submitBtnMyProfile={false}
                  typeSavePrimary={typeSavePrimary}
                  typeSaveSecondary={typeSaveSecondary}
                  inputs={contactDetailsInput}
                  onBack={contactDetailsBack}
                  onSave={save}
                  inputData={inputContactDetailsData}
                  contactDetails={inputContactDetailsInit}
                  typeValidation={typeValidation}
                  typePrimary={(value) => {
                    setTypeValidation({
                      primaryType: value,
                      secondaryType: typeValidation.secondaryType,
                    });
                  }}
                  typesecodary={(value) => {
                    setTypeValidation({
                      secondaryType: value,
                      primaryType: typeValidation.primaryType,
                    });
                  }}
                  phoneTypeMyProfile={false}
                  displayMyProfileEdit={false}
                />
              ) : (
                <UserRegistrationInputFirst
                  onUsername={onUsername}
                  onFirstName={onFirstName}
                  onLastName={onLastName}
                  onPassword={onPassword}
                  onConfirmPassword={onConfirmPassword}
                  onNetwork={onNetwork}
                  isPasswordActive={true}
                  validation={validation}
                  inputs={userDetailsInput}
                  onNext={userDetailsSubmit}
                  inputData={inputUserDetails}
                  isDisabled={false}
                  myProfNextBtn={false}
                />
              )}
            </div>
            <div className="footer-container">
              <Footer />
            </div>
          </div>
          <div className="loginbg-container">
            <div className="bgimage-text-wrapper">
              <span className="white-text">
                The one-stop solution<br></br>
              </span>
              <span className="white-text">
                for platform-independent<br></br>
              </span>
              <span className="green-text">
                doctor management<br></br>
              </span>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default UserRegistration;
